import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/loader/loader.service';
import { navigateAndThrow } from '../service/error-util';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const router = inject(Router);

  loaderService.show();

  return next(req).pipe(
    catchError((error) => navigateAndThrow(router, 'Error !', error)),
    finalize(() => setTimeout(() => loaderService.hide(), 500)),
  );
};
